// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react';
import { createRoot } from 'react-dom/client';

// Register HTTP interceptors + auto-disconnect after period of inactivity
import './utils/interceptors';
import '../utils/datadog-rum-init';
import '../utils/datadog-log-init';
import { setBaseUrl } from 'src/client/spendesk-api';
import appConfig from 'src/core/config';

import { assignVersionToWindow } from './common/utils/debugVersion';
import { App } from './modules/app';
import './styles.css';

if (!window.analytics) {
  window.analytics = null;
}

assignVersionToWindow();
setBaseUrl(appConfig.apiUrls.base);

const rootElement = document.getElementById('react__app-content');
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(<App />);
}
